import React, { useState } from 'react';

import ArrowRight from 'components/Icons/ArrowRight';
import Home from 'components/Icons/Home';
import VisuallyHidden from 'components/VisuallyHidden';
import colors from 'utils/colors';

import BackButton from './BackButton';
import ButtonContainer from './ButtonContainer';
import { BreadCrumbOption } from './interfaces';
import * as Styled from './styled';

export type ComponentProps = {
  /**
   * Items to render
   */
  items: BreadCrumbOption[];
};

export const BreadCrumb: React.FC<ComponentProps> = ({ items }) => {
  const [homeButtonHovered, setHomeButtonHovered] = useState(false);
  const [homeButtonFocused, setHomeButtonFocused] = useState(false);

  const showBackIcon = homeButtonHovered || homeButtonFocused;

  const onMouseEnterCallback = () => setHomeButtonHovered(true);
  const onMosueLeaveCallback = () => setHomeButtonHovered(false);
  const onFocusCallback = () => setHomeButtonFocused(true);
  const onBlurCallback = () => setHomeButtonFocused(false);

  const goHomePage = () => (window.location.href = 'https://www.service.vic.gov.au');

  return items.length > 0 ? (
    <Styled.Background>
      <Styled.Wrapper>
        <BackButton items={items} />
        <Styled.Container>
          <Styled.HomeButtonWrapper
            type='button'
            onMouseEnter={onMouseEnterCallback}
            onMouseLeave={onMosueLeaveCallback}
            onFocus={onFocusCallback}
            onBlur={onBlurCallback}
            onClick={goHomePage}
            role='link'>
            <VisuallyHidden>Homepage</VisuallyHidden>
            <Styled.HomeButtonIconHolder mode='main' showBackIcon={showBackIcon}>
              <Home fill={colors.orange} />
            </Styled.HomeButtonIconHolder>
            <Styled.HomeButtonIconHolder mode='secondary' showBackIcon={showBackIcon}>
              <ArrowRight fill={colors.orange} />
            </Styled.HomeButtonIconHolder>
          </Styled.HomeButtonWrapper>
        </Styled.Container>
        <ButtonContainer items={items} />
      </Styled.Wrapper>
    </Styled.Background>
  ) : null;
};

export default BreadCrumb;
